module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/start_quote-73a15a62b4721162f632245cb2458ec2.svg";